// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editorial-article h1,.editorial-article h2,.editorial-article h3,.editorial-article h4,.editorial-article p{all:unset;display:block}.editorial-article button{cursor:pointer}.editorial-article .body-text{font-weight:500;font-size:16px;line-height:150%}", ""]);
// Exports
module.exports = exports;
